// extracted by mini-css-extract-plugin
export default {"list":"ManufacturerItem_list__obSnd","container":"ManufacturerItem_container__5gEF-"};